import React, { Component } from 'react'
import TextField from '../TextField'
import SelectField from '../SelectField'
import CheckboxField from '../CheckboxField'
import HideFetched from './HideFetched'

const countries = require('../../data/countries.json');

export default class UserDetailForm extends Component {
  get availableCountries() {
    return countries.map(country => {
      return {label: country.name, value: `${country.id}`}
    })
  }

  get availableStates() {
    const { countryId } = this.props
    
    // eslint-disable-next-line
    const selectedCountry = countries.find(country => country.id == countryId)
    if(selectedCountry) {
      return selectedCountry.states.map(state => {
        return {label: state.code, value: `${state.id}`}
      })
    }
    else {
      return []
    }
  }

  render() {
    const { countryId, city, stateId, postalCode, termsAgreed, onChange, errors, fetchedParams } = this.props

    return (
      <div>
        <HideFetched name="countryId" fetchedParams={fetchedParams}>
          <div className="country-wrapper">
            <SelectField
              label="Country"
              value={countryId}
              availableValues={this.availableCountries}
              onChange={(val) => onChange("countryId", val)}
              error={errors.countryId}
            />
          </div>
        </HideFetched>

        <div className="row-wrapper">
          <HideFetched name="city" fetchedParams={fetchedParams}>
            <div className="city-wrapper">
              <TextField
                label="City"
                value={city}
                onChange={(val) => onChange("city", val)}
                error={errors.city}
              />
            </div>
          </HideFetched>


          <HideFetched name="stateId" fetchedParams={fetchedParams}>
            { this.availableStates.length > 0 &&
              <div className="state-wrapper">
                <SelectField
                  label="State"
                  value={stateId}
                  availableValues={this.availableStates}
                  onChange={(val) => onChange("stateId", val)}
                  error={errors.stateId}
                />
              </div>
            }
          </HideFetched>

          <HideFetched name="postalCode" fetchedParams={fetchedParams}>
            <div className="postal-code-wrapper">
              <TextField
                label="Zip or Postal Code"
                value={postalCode}
                onChange={(val) => onChange("postalCode", val)}
                error={errors.postalCode}
              />
            </div>
          </HideFetched>
        </div>

        <div className="terms-wrapper">
          <CheckboxField
            id="terms-checkbox"
            label="I agree to the terms and conditions"
            labelUrl="/terms"
            checked={termsAgreed}
            onChange={(val) => onChange("termsAgreed", val)}
            error={errors.termsAgreed}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SignupWidget/UserDetailForm.js